import cn from 'classnames'
import React from 'react'
import styled from 'react-emotion'
import { SVGIcon } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

import ToggleKbSearchDropdown from './Dropdown'
import WithUpdateSidebar from './WithUpdateSidebar'

const HoverSVGIcon = styled(SVGIcon)`
  color: ${themeVars.ultraLight};
  cursor: pointer;
  height: 20px;

  &:hover,
  &.active {
    color: ${themeVars.groovy};
  }
`

const tooltipConfig = {
  tooltip: 'Show knowledge base toolbar',
  position: 'top',
}

export default function ToggleKbSearchView({
  className,
  toggleKnowledgebaseToolbar,
  hasKnowledgebases,
  isOpen,
}) {
  return (
    <ToggleKbSearchDropdown
      className={className}
      key="toggle-kb-search"
      onClick={toggleKnowledgebaseToolbar}
      hasKnowledgebases={hasKnowledgebases}
      isOpen={isOpen}
      trigger={
        <WithUpdateSidebar>
          <HoverSVGIcon
            className={cn({ active: isOpen })}
            name="knowledgeBase"
            size={16}
            withTooltip={tooltipConfig}
          />
        </WithUpdateSidebar>
      }
      upward
    />
  )
}
